import { render, staticRenderFns } from "./buttomcard.vue?vue&type=template&id=670790d5&"
import script from "./buttomcard.vue?vue&type=script&lang=js&"
export * from "./buttomcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports